import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";

export default function RequireAdmin({ children }) {
    const {user, isLoggedIn} = useAuth();
    const location = useLocation();

    if (!isLoggedIn) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }
    
    if (user.authorityType !== "ADMIN") {
        return <Navigate to="/" replace />
    }

    return children;
}